import { httpServiceClient } from '@/infra/http'
import { makeApiUrl } from '@/main/factories/http/api-url-factory'
import { UserPDIItemListModel } from './idp-service-types'

export const createIdpService = (client = httpServiceClient) => ({
  async fetchLatestWeakness(): Promise<UserPDIItemListModel> {
    const response = await client<UserPDIItemListModel>({
      method: 'get',
      url: makeApiUrl('/v2/user/idp/latest/weakness')
    })

    return response?.body?.data ?? []
  }
})

export const idpService = createIdpService()

export const SEARCH_QUERY_KEY = 'user_idp_search'
